import React, { useEffect, useState } from "react";
import userImage from "../../../assets/images/profile-sample.jpg";
import background from "../../../assets/images/birthdayBg.png";
import birthday4 from "../../../assets/images/birthday.jpg";
import DefaultCheckbox from "../../../components/inputs/defaultCheckbox";
import DefaultButton from "../../../components/buttons/defaultButton";
import { HiDownload } from "react-icons/hi";
import { IoMdCheckmark } from "react-icons/io";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import { updateWorkspace } from "../../../../services/workspace/workspace.service";
import toast from "react-hot-toast";

const BirthdayTemplates = () => {
  const [selectedCard, setSelectedCard] = useState(null);
  // Since we removed workspace slice, provide a fallback
  const default_workspace = {
    name: "School"
  };

  const handleSelect = (cardId) => {
    setSelectedCard((prev) => (prev === cardId ? null : cardId));
    updateTemplate(cardId);
  };

  const updateTemplate = async (cardId) => {
    try {
      const payload = {
        default_birthday: parseInt(cardId),
        
      };
      if (default_workspace?.uuid) {
        const response = await updateWorkspace(payload, default_workspace?.uuid);
        if (response) {
          toast.success("Template updated successfully!");
        } else {
          toast.error("Failed to update template!.");
        }
      } else {
        toast.error("Failed to update workspace!.");
      }
    } catch (error) {
      toast.error("Failed to update workspace!.");
    }
  };

  useEffect(() => {
    if (default_workspace?.default_birthday) {
      setSelectedCard(default_workspace?.default_birthday);
    }
  }, [default_workspace]);

  const sampleData = [
    {
      name: "Yashika",
      class: "5th-A",
      id: "634672",
      image: userImage,
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 xl:grid-cols-4 gap-4">
        {sampleData.map((data, idx) => (
          <React.Fragment key={idx}>
            <BirthdayCard1
              data={data}
              cardId={0}
              selectedCard={selectedCard}
              handleSelect={handleSelect}
            />
            <BirthdayCard2
              data={data}
              cardId={1}
              selectedCard={selectedCard}
              handleSelect={handleSelect}
            />
            <BirthdayCard3
              data={data}
              cardId={2}
              selectedCard={selectedCard}
              handleSelect={handleSelect}
            />
            <BirthdayCard4
              data={data}
              cardId={3}
              selectedCard={selectedCard}
              handleSelect={handleSelect}
            />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export const BirthdayCard1 = ({ data, cardId, selectedCard, handleSelect }) => {
  const isSelected = selectedCard === cardId;
  return (
    <div
      onClick={() => handleSelect(cardId)}
      className="group relative bg-gradient-to-br from-pink-400 to-yellow-300 w-full h-96 rounded-lg text-white flex flex-col justify-center items-center p-4 text-center cursor-pointer"
    >
      <h2 className="text-2xl font-bold">Happy Birthday 🎂</h2>
      <img
        src={data.image}
        className="w-24 h-24 rounded-full border-4 border-white my-3 object-cover"
        alt="birthday4"
      />
      <h3 className="text-lg font-semibold">{data.name}</h3>
      <p className="text-sm">
        (Class: {data.class} | Roll No: {data.id})
      </p>
      <p className="mt-4 text-sm italic">
        Happy Birthday! Wishing you a year filled with joy, good health, and
        continued success in all you do.
      </p>

      {isSelected && (
        <div
          className="absolute inset-0 rounded-lg bg-black/30 flex justify-end z-40 p-4"
          onClick={() => handleSelect(cardId)}
        >
          <IoCheckmarkCircleOutline className="text-green-600 text-4xl" />
        </div>
      )}
    </div>
  );
};

export const BirthdayCard2 = ({ data, cardId, selectedCard, handleSelect,   }) => {
  const isSelected = selectedCard === cardId;
  return (
    <div className="relative w-full h-96">
      <div
        onClick={() => handleSelect(cardId)}
        className="group w-full h-full bg-white rounded-lg text-center relative overflow-hidden border cursor-pointer"
      >
        <img
          src={background}
          className="absolute inset-0 w-full h-full object-cover opacity-20"
          alt="birthday"
        />
        <div className="relative z-10 flex flex-col items-center justify-center h-full p-4 text-primary-800">
          <h2 className="text-xl font-bold">🌸 Happy Birthday</h2>
          <img
            src={data.image}
            className="w-24 h-24 rounded-full border-4 border-pink-300 my-3 object-cover"
            alt="user"
          />
          <h3 className="text-lg font-bold">{data.name}</h3>
          <p className="text-sm">
            Class: {data.class} - Roll No: {data.id}
          </p>
          <p className="mt-2 text-sm">
            Happy Birthday! Wishing you a year filled with joy, good health, and
            continued success in all you do.
          </p>
        </div>

        {isSelected && (
          <div
            className="absolute inset-0 rounded-lg bg-black/30 flex justify-end z-40 p-4"
            onClick={() => handleSelect(cardId)}
          >
            <IoCheckmarkCircleOutline className="text-green-600 text-4xl" />
          </div>
        )}
      </div>
    </div>
  );
};

export const BirthdayCard3 = ({ data, cardId, selectedCard, handleSelect, selectedStudent, handleSelectStudent }) => {
  const isSelected = selectedCard === cardId;
  return (
    <div
      onClick={() => handleSelect(cardId)}
      className="group w-full h-96 bg-blue-100 rounded-lg text-center p-4 relative overflow-hidden cursor-pointer"
    >
      <div className="absolute top-0 left-0 w-full h-24 bg-blue-300 rounded-b-full z-0" />
      <div className="relative z-10 flex flex-col items-center mt-8">
        <h2 className="text-xl font-bold text-blue-700">🎈 Happy B'day</h2>
        <img
          src={data.image}
          className="w-24 h-24 rounded-full border-4 border-white my-3 object-cover"
          alt="birthday2"
        />
        <h3 className="text-blue-800 font-semibold">{data.name}</h3>
        <p className="text-sm text-blue-600">
          (Class: {data.class} | {data.id})
        </p>
        <p className="mt-4 text-xs text-blue-700 italic">
          Happy Birthday! Wishing you a year filled with joy, good health, and
          continued success in all you do. 🎂
        </p>
      </div>

      {isSelected && (
        <div
          className="absolute inset-0 rounded-lg bg-black/30 flex justify-end z-40 p-4"
          onClick={() => handleSelect(cardId)}
        >
          <IoCheckmarkCircleOutline className="text-green-600 text-4xl" />
        </div>
      )}
    </div>
  );
};

export const BirthdayCard4 = ({ data, cardId, selectedCard, handleSelect, selectedStudent, handleSelectStudent }) => {
  const isSelected = selectedCard === cardId;
  return (
    <div
      onClick={() => handleSelect(cardId)}
      className="group relative w-full h-96 bg-white border border-gray-200 rounded-lg p-2 flex flex-col items-center justify-between text-center cursor-pointer"
    >
      <img
        src={background}
        className="absolute inset-0 w-full h-full object-cover opacity-20"
        alt="birthday"
      />
      <img
        src={birthday4}
        className="w-40 h-20 border-gray-400 object-cover"
        alt="birthday3"
      />
      <div className="bg-white mt-2 border-2 rounded-t-md p-2">
        <img
          src={data.image}
          className="w-40 h-36 border-gray-400 object-cover rounded-t-md"
          alt="birthday3"
        />
        <h3 className="pt-2 text-sm text-gray-900">{data.name}</h3>
      </div>

      <div>
        <p className="text-sm text-gray-600">Class: {data.class}</p>
        <p className="text-xs text-gray-400">Roll No: {data.id}</p>
      </div>
      <p className="text-xs italic text-gray-700">
        Happy Birthday! Wishing you a year filled with joy, good health, and
        continued success in all you do. 🎉
      </p>

      {isSelected && (
        <div
          className="absolute inset-0 rounded-lg bg-black/30 flex justify-end z-40 p-4"
          onClick={() => handleSelect(cardId)}
        >
          <IoCheckmarkCircleOutline className="text-green-600 text-4xl" />
        </div>
      )}
    </div>
  );
};

export default BirthdayTemplates;
